<template>
  <div class="billing-descriptor-wrapper" :class="{ 'billing-descriptor-wrapper--luxliebe': theme === 'luxliebe' }">
    <MerchantInformation compact />
    <component :is="theme === 'luxliebe' ? 'button' : 'div'" :type="theme === 'luxliebe' ? 'button' : undefined" :aria-expanded="theme === 'luxliebe' ? billingDescriptorDropdown : undefined" class="billing-descriptor" :class="billingDescriptorDropdown?'active':''" @click="billingDescriptorDropdown = !billingDescriptorDropdown">
      {{ $t('credits.billing_descriptor') }}: Halosauridae SD
      <svg xmlns="http://www.w3.org/2000/svg" width="9.29" height="6"><g data-name="Group 55"><path d="M4.154 5.795.201 1.845a.694.694 0 0 1 0-.985l.66-.655a.694.694 0 0 1 .985 0l2.8 2.8 2.8-2.8a.694.694 0 0 1 .985 0l.656.656a.694.694 0 0 1 0 .985l-3.95 3.95a.691.691 0 0 1-.982 0Z" data-name="Icon awesome-angle-down"/></g></svg>
    </component>
    <div class="billing-descriptor-dropdown" v-if="billingDescriptorDropdown">
      <p><strong>{{ $t('credits.statement') }}:</strong> Halosauridae SD or UG*Halosaurid35799268865<br>
        <template v-if="theme !== 'luxliebe'">{{ $t('credits.registered') }}: Riga Feraiou 7-9, Lizantia Court, Flat/Office 310, Agioi Omologites, 1087 Nicosia, Cyprus.<br></template>
        {{ $t('credits.trading') }}: Skopa 5, Anemona Court, Flat/Office 105, Strovolos, 2035 Nicosia, Cyprus.<br>
        {{ $t('credits.registration') }}#: HE375841</p>
    </div>
  </div>
</template>

<script>
import ThemeMixin from "@/mixins/ThemeMixin";
import MerchantInformation from "./MerchantInformation.vue";

export default {
  name: "BillingInformation",
  mixins: [ThemeMixin],
  components: { MerchantInformation },
  data() {
    return { billingDescriptorDropdown: false };
  },
};
</script>

<style scoped lang="scss">
.billing-descriptor-wrapper {
  position: relative;

  @media (max-width: 991px) {
    max-width: calc(100% - 40px);
    margin: 20px auto 0;
  }
}

.billing-descriptor-dropdown {
  width: 100%;
  background-color: #fff;
  border: 1px solid $color-credits-border;
  padding: 20px 20px;
  border-radius: 20px;
  margin-top: 5px;

  p {
    line-height: 1.7;
    font-size: 12px;
    margin-bottom: 0;
    color: $color-credits-type3;
    font-weight: 500;

    strong {
      color: $color-credits-type5;
    }
  }
}

.billing-descriptor {
  margin-top: 30px;
  padding: 30px;
  border-radius: 20px;
  background-color: #fff;
  border: 1px solid $color-credits-border;
  color: $color-credits-type3;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  svg {
      margin-left: 10px;
  }

  &.active {
      svg {
          transform: rotate(-180deg);
      }
  }

  @media (max-width: 991px) {
    padding: 15px 20px;
    margin: 20px auto 0;
  }
}

.billing-descriptor-wrapper--luxliebe {
  margin-top: 30px;
  padding: 20px;
  border: 1px solid $color-credits-border;
  border-radius: 20px;
  background-color: #fff;
  color: $color-credits-type3;

  .billing-descriptor {
    width: 100%;
    margin: 16px 0 0;
    padding: 16px 0 0;
    border: 0;
    border-top: 1px solid $color-credits-border;
    border-radius: 0;
    font-family: inherit;
    text-align: left;

    &:focus-visible {
      outline: 2px solid $color-credits-type3;
      outline-offset: 4px;
    }
  }

  .billing-descriptor-dropdown {
    width: auto;
    margin: 0;
    padding: 12px 0 0;
    border: 0;
    border-radius: 0;
    overflow-wrap: anywhere;
  }

  @media (max-width: 991px) {
    margin-top: 20px;
    padding: 16px;
  }
}
</style>
